import { Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SiteHeader, SiteFooter } from "@/components/marketing/SiteChrome";

export default function PublicLayout() {
  const { user } = useAuth();
  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <SiteHeader user={user} />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
